import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line lodash/import-scope
import capitalize from 'lodash/capitalize';

import { AdvertiserDisclosure } from '@nerdwallet/currency';

import { stringSelectSpec, boolCheckboxSpec } from '../../lib/editing-configs';

const disclosures = {
  default: null,
  investing: 'investing',
};

export const disclosureTypes = Object.keys(disclosures);

const Disclosure = ({ type, color, onBackground }) => (
  <div className="advertiser-disclosure-wrapper">
    <AdvertiserDisclosure
      color={!onBackground && color}
      onBackground={onBackground}
      type={type === disclosures.investing ? 'investing' : 'credit_cards'}
    />
  </div>
);

Disclosure.propTypes = {
  type: PropTypes.oneOf(disclosureTypes),
  color: PropTypes.string,
  onBackground: PropTypes.bool,
};

Disclosure.defaultProps = {
  onBackground: false,
};

Disclosure.getEditingConfig = () => [
  stringSelectSpec(
    'disclosureType',
    'Advertiser disclosure popup',
    ['none', ...disclosureTypes].map((type) => ({
      value: type,
      label: capitalize(type),
    }))
  ),
  boolCheckboxSpec('disclosureOnBackground', 'On a colorful/dark background?'),
];

export default Disclosure;
